import { REGEX } from '../constants';

export const removeLastBracketPair = (str: string): string =>
  str.replace(REGEX?.REPLACE_BRACKETS_AND_TEXT, '');
